export default "__VITE_ASSET__CbwqHdj2__"